/**
 * Defines a Popper modifier that will set the value of `pvdCurrentPlacement`
 * based on Popper's placement.
 */
function getCurrentPlacementPopperModifier() {
    var _this = this;
    return {
        name: 'placement',
        enabled: true,
        phase: 'beforeWrite',
        requires: ['flip'],
        fn: function (_a) {
            var state = _a.state;
            if (_this.pvdCurrentPlacement !== state.placement) {
                _this.pvdCurrentPlacement = state.placement;
            }
        },
    };
}

export { getCurrentPlacementPopperModifier };
